"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbNotifications = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _shapes = require("../../skybase-core/shapes");

var _sbButton = require("../sb-button/sb-button");

var _locales = require("../../skybase-core/locales");

var _constants = require("../../skybase-core/notifications/constants");

var _sbLocale = require("../sb-locale");

var _shapes2 = require("./shapes");

var _sbNotificationsI18n = require("./sb-notifications-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getAlertIcon = function getAlertIcon(type) {
  var icon = type === _constants.ALERT_TYPE_INFO ? 'sbi-help-info' : 'sbi-alert';
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("i", {
    className: icon
  }));
};

var getMessageClass = function getMessageClass(type) {
  if (type) {
    return {
      'sb-notification': true,
      'fl-align-items-center': true,
      'color-error': type === _constants.ALERT_TYPE_ERROR,
      'color-warning': type === _constants.ALERT_TYPE_WARNING,
      'color-inactive': type === _constants.ALERT_TYPE_INFO
    };
  }

  return {};
}; // eslint-disable-next-line no-underscore-dangle


var _SbNotifications = /*#__PURE__*/function (_Component) {
  _inherits(_SbNotifications, _Component);

  var _super = _createSuper(_SbNotifications);

  function _SbNotifications() {
    var _this;

    _classCallCheck(this, _SbNotifications);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOnRemoveNotificationClick", function (e, notification) {
      e.nativeEvent.stopImmediatePropagation();
      e.stopPropagation();
      var onRemoveNotificationClick = _this.props.onRemoveNotificationClick;
      onRemoveNotificationClick(notification);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDateTime", function (date, relativeDateTime) {
      var _this$props = _this.props,
          locale = _this$props.intl.locale,
          _this$props$sbLocale = _this$props.sbLocale,
          getLocaleFormat = _this$props$sbLocale.getLocaleFormat,
          format = _this$props$sbLocale.format;

      if (relativeDateTime) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "sb-notification-date"
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedRelativeTime, {
          value: (date - Date.now()) / 1000,
          numeric: "auto",
          updateIntervalInSeconds: 10
        })));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-notification-date"
      }, /*#__PURE__*/_react.default.createElement("div", null, format({
        value: new Date(date),
        format: getLocaleFormat().dateFormat,
        locale: locale
      })), /*#__PURE__*/_react.default.createElement("div", null, format({
        value: new Date(date),
        format: getLocaleFormat().timeFormat,
        locale: locale
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderRemoveButton", function (closeButton, notification, id) {
      if (closeButton) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          id: "".concat(id, "-close-button"),
          className: "sbi-close",
          onClick: function onClick(e) {
            return _this.handleOnRemoveNotificationClick(e, notification);
          }
        }));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderEmptyList", function () {
      var _ = _this.props.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-notification"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-notification-message"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-help-info"
      }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, _(_sbNotificationsI18n.messages.noIssuesFound)), /*#__PURE__*/_react.default.createElement("div", null, _(_sbNotificationsI18n.messages.thereAreNoAlertsAtThisTime)))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderNotification", function (notification) {
      var _this$props2 = _this.props,
          relativeDateTime = _this$props2.relativeDateTime,
          onNotificationClick = _this$props2.onNotificationClick,
          _ = _this$props2.intl.formatMessage;
      var className = notification.className,
          id = notification.id,
          date = notification.time,
          severity = notification.severity,
          title = notification.title,
          _notification$titlePa = notification.titleParams,
          titleParams = _notification$titlePa === void 0 ? {} : _notification$titlePa,
          message = notification.message,
          _notification$message = notification.messageParams,
          messageParams = _notification$message === void 0 ? {} : _notification$message,
          closeButton = notification.notificationParams.closeButton;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: id,
        id: id,
        className: (0, _classnames.default)(getMessageClass(severity), className),
        onClick: function onClick() {
          return onNotificationClick(notification);
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-notification-message"
      }, getAlertIcon(severity), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, (0, _locales.translateMessage)(_, title, titleParams)), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-notification-alert-message"
      }, (0, _locales.translateMessage)(_, message, messageParams)))), _this.renderDateTime(date, relativeDateTime), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-notification-reset"
      }, _this.renderRemoveButton(closeButton, notification, id)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderHistoryButton", function () {
      var _this$props3 = _this.props,
          onAllAlarmsAndWarningsClick = _this$props3.onAllAlarmsAndWarningsClick,
          renderAllItemsButton = _this$props3.renderAllItemsButton,
          _ = _this$props3.intl.formatMessage,
          summaryId = _this$props3.summaryId;

      if (renderAllItemsButton) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "sb-notification-link"
        }, /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
          id: summaryId,
          onClick: function onClick() {
            return onAllAlarmsAndWarningsClick();
          }
        }, _(_sbNotificationsI18n.messages.alertsAndDetailsSummary)));
      }

      return null;
    });

    return _this;
  }

  _createClass(_SbNotifications, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          id = _this$props4.id,
          notifications = _this$props4.notifications,
          expanded = _this$props4.expanded,
          notificationsLimit = _this$props4.notificationsLimit,
          style = _this$props4.style;
      var notificationsList = [];
      var notificationLink;

      if (expanded) {
        notificationLink = this.renderHistoryButton();

        if (notifications.length) {
          notificationsList = notifications.slice(0, notificationsLimit).map(function (notification) {
            return _this2.renderNotification(notification);
          });
        } else {
          notificationsList = this.renderEmptyList();
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('sb-notifications', className),
        id: id,
        style: style
      }, notificationsList, notificationLink);
    }
  }]);

  return _SbNotifications;
}(_react.Component);

_defineProperty(_SbNotifications, "propTypes", {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  notificationsLimit: _propTypes.default.number,
  notifications: _propTypes.default.arrayOf(_shapes2.notificationShape),
  expanded: _propTypes.default.bool,
  onNotificationClick: _propTypes.default.func,
  onRemoveNotificationClick: _propTypes.default.func,
  onAllAlarmsAndWarningsClick: _propTypes.default.func,
  relativeDateTime: _propTypes.default.bool,
  style: _propTypes.default.object,
  // eslint-disable-line
  intl: _shapes.intlShape.isRequired,
  summaryId: _propTypes.default.string,
  sbLocale: _sbLocale.sbLocaleShape.isRequired,
  renderAllItemsButton: _propTypes.default.bool
});

_defineProperty(_SbNotifications, "defaultProps", {
  className: null,
  id: null,
  notifications: [],
  expanded: false,
  onNotificationClick: function onNotificationClick() {},
  onRemoveNotificationClick: function onRemoveNotificationClick() {},
  onAllAlarmsAndWarningsClick: null,
  notificationsLimit: 10,
  relativeDateTime: false,
  style: null,
  summaryId: null,
  renderAllItemsButton: true
});

var SbNotifications = (0, _reactIntl.injectIntl)((0, _sbLocale.injectSbLocale)(_SbNotifications));
exports.SbNotifications = SbNotifications;
//# sourceMappingURL=sb-notifications.js.map